import React, { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { withNamespaces } from 'react-i18next';
import { BACKEND_URL } from "../../../services/backendURL";

class TasksDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu
    }));
  }
  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="dropdown d-inline-block"
          tag="li"
        >
          <DropdownToggle
            className="btn header-item noti-icon waves-effect"
            tag="button" id="page-header-notifications-dropdown">
            <i className={'bx bx-briefcase' + (this.props.task_nr === 0 ? '' : ' ')}></i>
            <span 
              style={this.props.task_nr === 0 ? {display:'none'} : {}}
              className="badge badge-danger badge-pill">
              {this.props.task_nr}
            </span>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0" right>
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {this.props.t('Detyrat')} </h6>
                </Col>
                <div className="col-auto">
                  <span style={{fontSize: '13px',color:'#b821b3'}} onClick={this.props.allTasks} className="small"> Shiko të Gjitha</span>
                </div>
              </Row>
            </div>

            <SimpleBar style={{ height: "250px" }}>
            
            {this.props.notif_tasks.length === 0 ?
              <div className="text-center mt-2">
                <p>
                  Nuk ka detyra te reja.
                </p>
              </div>
            : ""}
              
            {this.props.notif_tasks && this.props.notif_tasks.map(
              (opt, index) => {return (
                <div key={"headerlink_"+index} onClick={()=>this.props.singleTask(index)} className="text-reset notification-item pointer">
                  <div className="media">
                    { opt.task && opt.task.create_member && opt.task.create_member.photo ? 
                      <img src={BACKEND_URL + opt.task.create_member.photo} className="rounded-circle avatar-xs mr-3" alt="" /> 
                    : ""}
                    { opt.task && opt.task.create_member && opt.task.create_member.name && !opt.task.create_member.photo ? 
                      <div className="avatar-xs mr-3"> 
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                            {opt.task.create_member.name.charAt(0)}
                        </span>
                      </div>
                    : ""}
                    { !opt.task.create_member ?
                    <div className="avatar-xs mr-3"> 
                      <span className="avatar-title bg-primary rounded-circle font-size-16">
                        A
                      </span>
                    </div>
                    : ""}

                    <div className="media-body">
                      <h6 className="mt-0 mb-1">{opt.task.create_member ? opt.task.create_member.name + " " + opt.task.create_member.surname : ""}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-1">{opt.task.name}</p>
                        <p className="mb-0"><i className="mdi mdi-clock-outline"></i> {opt.start_date? opt.start_date.slice(0,10): "" } </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            )}

            </SimpleBar>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}
export default withNamespaces()(TasksDropdown);
